import actionTypes from '../constants/action-types';
import constants from '../constants';
import getNextUndo from '../selectors/next-undo';
import getNextRedo from '../selectors/next-redo';
import getStatus from '../selectors/status';
import invertMutation from '../helpers/invert-mutation';

const mutationInverter = (store) => (next) => (action) => {
  switch (action.type) {
    case actionTypes.UNDO: {
      const state = store.getState();
      const status = getStatus(state);
      const mutation = getNextUndo(state);

      if (status !== constants.STATUS_PENDING || !mutation) return;

      const undoAction = invertMutation(mutation);

      next(action);
      store.dispatch(undoAction);
      break;
    }

    case actionTypes.REDO: {
      const state = store.getState();
      const status = getStatus(state);
      const mutation = getNextRedo(state);

      if (status !== constants.STATUS_PENDING || !mutation) return;

      const redoAction = invertMutation(mutation);

      next(action);
      store.dispatch(redoAction);
      break;
    }

    default: {
      next(action);
      break;
    }
  }
};

export default mutationInverter;
